export const SET_SSO_TOKEN = "SET_SSO_TOKEN";
